// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"72cf64c4","55":"2f893c91","77":"54069149","126":"80fa5256","171":"0762f47e","382":"c2e63c6c","456":"4168b638"}[chunkId] + ".chunk.js";
};